module.exports = __webpack_public_path__ + "img/industriezaun.24291d80.webp";